module.exports = __webpack_public_path__ + "img/locate@2x.48cbdc52.png";